import "./Card.css";
import icon_11 from "../../../../assets/icon_11.png";
import icon_12 from "../../../../assets/icon_12.png";
import icon_10 from "../../../../assets/icon_10.png";

const Card = () => {
 return (
  <div className="cardShap-container">
   <div className="cardShap">
    <div className="wrapper">
     <div className="cardShap-left">
      <p className="cardShap-title">AVAILABLE BALANCE</p>
      <p className="cardShap-text">$2,489</p>
     </div>
     <div className="cardShap-right">
      <img src={icon_10} alt="product" />
     </div>
    </div>
   </div>

   <div className="cardShap">
    <div className="wrapper">
     <div className="cardShap-left">
      <p className="cardShap-title">TOTAL EARNINGS</p>
      <p className="cardShap-text">$2,489</p>
     </div>
     <div className="cardShap-right">
      <img src={icon_11} alt="product" />
     </div>
    </div>
   </div>

   <div className="cardShap">
    <div className="wrapper">
     <div className="cardShap-left">
      <p className="cardShap-title">TOTAL SALES</p>
      <p className="cardShap-text">23</p>
     </div>
     <div className="cardShap-right">
      <img src={icon_12} alt="product" />
     </div>
    </div>
   </div>
  </div>
 );
};

export default Card;
